import { render } from "./UsesView.vue?vue&type=template&id=b3d5379c&scoped=true"
import script from "./UsesView.vue?vue&type=script&lang=js"
export * from "./UsesView.vue?vue&type=script&lang=js"

import "./UsesView.vue?vue&type=style&index=0&id=b3d5379c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d5379c"]])

export default __exports__